import {
  TooltipArrow,
  type TooltipContentProps,
} from "@radix-ui/react-tooltip";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@workspace/ui/components/tooltip";
import { cn } from "@workspace/ui/lib";
import { type PropsWithChildren, type ReactNode } from "react";

interface TooltipWrapperProps
  extends PropsWithChildren,
    Omit<TooltipContentProps, "content"> {
  content: ReactNode;
  isDisabled?: boolean;
  asChild?: boolean;
  isArrow?: boolean;
}

export const TooltipWrapper = ({
  children,
  content,
  isDisabled = false,
  isArrow = false,
  asChild = true,
  side = "right",
  ...contentProps
}: TooltipWrapperProps) => {
  if (isDisabled) {
    return <>{children}</>;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild={asChild}>{children}</TooltipTrigger>
        <TooltipContent
          {...contentProps}
          className={cn(contentProps.className, "whitespace-pre-wrap")}
          side={side}
        >
          {isArrow && <TooltipArrow />}
          {content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
